/**
 * @generated SignedSource<<f579b3a342652b88b66dde90c060543b>>
 * @relayHash 807e5144d28a5a03c258339921b90265
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 95536348ae5510b8573299213aea1b3064e606200ad4fc05f36ec8dfa2c1df76

import type { ConcreteRequest, Query } from 'relay-runtime';
export type CsmAiWidgetBrandingChatColorVibeVariant = "DARK" | "DEFAULT" | "LIGHT" | "VIBRANT" | "%future added value";
export type CsmAiWidgetBrandingColorVibeVariant = "DARK" | "LIGHT" | "VIBRANT" | "%future added value";
export type CsmAiWidgetBrandingRadius = "NORMAL" | "ROUNDED" | "SHARP" | "%future added value";
export type CsmAiWidgetBrandingSpaceVariant = "COMFORTABLE" | "COSY" | "GENEROUS" | "%future added value";
export type CsmAiWidgetPosition = "CENTER" | "CORNER" | "%future added value";
export type supportWidgetConfigProviderQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type supportWidgetConfigProviderQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly id?: string;
    readonly widgets?: ReadonlyArray<{
      readonly id?: string;
      readonly isEnabled?: boolean | null | undefined;
      readonly position?: CsmAiWidgetPosition;
      readonly theme?: {
        readonly chatColor: CsmAiWidgetBrandingChatColorVibeVariant;
        readonly colorVibeVariant: CsmAiWidgetBrandingColorVibeVariant;
        readonly radius: CsmAiWidgetBrandingRadius;
        readonly space: CsmAiWidgetBrandingSpaceVariant;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly helpCenter: {
    readonly helpCenterById: {
      readonly helpCenterBranding?: {
        readonly colors: {
          readonly primary: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type supportWidgetConfigProviderQuery = {
  response: supportWidgetConfigProviderQuery$data;
  variables: supportWidgetConfigProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "HelpCenterBranding",
      "kind": "LinkedField",
      "name": "helpCenterBranding",
      "plural": false,
      "selections": [
        {
          "concreteType": "HelpCenterBrandingColors",
          "kind": "LinkedField",
          "name": "colors",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "primary"
            }
          ]
        }
      ]
    }
  ],
  "type": "HelpCenter"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "SUPPORT_SITE"
  }
],
v7 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/),
    {
      "concreteType": "CsmAiWidgetBrandingTheme",
      "kind": "LinkedField",
      "name": "theme",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "colorVibeVariant"
        },
        {
          "kind": "ScalarField",
          "name": "space"
        },
        {
          "kind": "ScalarField",
          "name": "radius"
        },
        {
          "kind": "ScalarField",
          "name": "chatColor"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "position"
    },
    {
      "kind": "ScalarField",
      "name": "isEnabled"
    }
  ],
  "type": "CsmAiWidgetConfig"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "supportWidgetConfigProviderQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "args": (v6/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v7/*: any*/)
                ],
                "storageKey": "widgets(type:\"SUPPORT_SITE\")"
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "supportWidgetConfigProviderQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "HelpCenterQueryApi",
        "kind": "LinkedField",
        "name": "helpCenter",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "helpCenterById",
            "plural": false,
            "selections": [
              (v8/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v5/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ]
          }
        ]
      },
      {
        "args": (v3/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              {
                "args": (v6/*: any*/),
                "kind": "LinkedField",
                "name": "widgets",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": "widgets(type:\"SUPPORT_SITE\")"
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "95536348ae5510b8573299213aea1b3064e606200ad4fc05f36ec8dfa2c1df76",
    "metadata": {},
    "name": "supportWidgetConfigProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "128f3a126c0ed20b8c90f848f9e4054b";

export default node;
